// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Button } from "react-bootstrap";

import { withRouter } from "view/reactrouterinterceptor";
import {
  SiteBarComponent,
  mapDispatchToProps as siteBarDispatch,
  mapStateToProps as siteBarProps,
} from "./SiteBar";

import "./SiteBar.scss";

class EnergyMeterSiteBarComponent extends SiteBarComponent {
  public override renderBackButton() {
    if (this.props.showBackButton) {
      return (
        <Button
          id="navigate-back"
          variant="secondary"
          className="btn-header me-3"
          onClick={() => this.props.navigate(-1)}
        >
          <FormattedMessage id="Back to Timeseries" />
        </Button>
      );
    }
    return null;
  }
}

export default connect(siteBarProps, siteBarDispatch)(withRouter(EnergyMeterSiteBarComponent));
